import React, { ChangeEvent, Component, useState } from "react";
import "./HubspotPullCompanies.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import IHubspotPullCompaniesDTO from "../../../../models/DTO/IHubspotPullCompaniesDTO";
import OwTitle from "../../../shared/OwTitle/OwTitle";

type Props = {
    closeModalFn: () => void;
    startModalFn: (options: Partial<IHubspotPullCompaniesDTO>) => void;
};

export const HubspotPullCompanies: React.FC<Props> = (props) => {
    const [payload, setPayload] = useState<Partial<IHubspotPullCompaniesDTO>>({});

    const closeModal = () => {
        props.closeModalFn();
    };

    const start = () => {
        props.startModalFn(payload);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const existingPayload = {
            ...payload,
        };

        // @ts-expect-error
        existingPayload[name] = value;

        setPayload(existingPayload);
    };

    return (
        <div className={"HubspotPullCompanies p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-download-alt"} title={"pull_customers"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div className={"mt-2"}>
                    <OwCheckbox
                        name={"connectOnly"}
                        checked={payload.connectOnly}
                        label={"connect_only"}
                        fn={handleChange}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>

                <div className={"mt-4"}>
                    <OwCheckbox
                        name={"includeContacts"}
                        checked={payload.includeContacts}
                        label={"include_contacts"}
                        fn={handleChange}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>

                <div className={"mt-4"}>
                    <OwButton title={"start"} fn={start} />
                </div>
            </div>
        </div>
    );
};
